<template>
  <div class="visit-register">
    <div class="visit-register-header">
      <div class="logo-2">
        <img src="@/assets/images/logo-lg.svg" alt="-visipoint-logo" />
      </div>
      <div
        v-if="getDifferentUserType || getFromLogin || !getRegisterPassportAcc"
        class="reg-header"
      >
        {{ $t('common.register')}}
      </div>
    </div>

    <div
      v-if="getNotAllowedToRegister"
      class="diff-user-type-main-content-pass"
      :class="{ 'passport-diff-user-type-main-content-pass': getFromLogin }"
    >
      <div
        class="reg-title"
        :class="{ 'diff-reg-title': getRegisterPassportAcc }"
      >
        {{ $t('preRegisteration.registration_not_allowed') }}
      </div>
      <div class="reg-txtmsg">
        {{ $t('preRegisteration.staff_user_type',{userType:getUserTypeName}) }}
      </div>

      <button
        v-if="getFromLogin"
        @click="redirectTo()"
        class="noqr-next-btn activ-btn"
        style="margin-top: 45px"
        size="lg"
      >
        {{ $t('preRegisteration.go_to_passport') }}
      </button>

      <div class="with-wrapper" v-if="getRegisterPassportAcc">
        <div class="sep-line"></div>

        <p class="wrapper-line">
          {{ $t('preRegisteration.passport_created')}}
        </p>
      </div>

      <div v-if="getRegisterPassportAcc && getEmail" class="login-wrapper">
        <img
          class="check-email-icon"
          src="@/assets/images/check-email.svg"
          alt="check your email"
        />
        <p class="check-email-title">{{ $t('preRegisteration.checkEmail') }}</p>
        <p class="check-email-msg">
          {{ $t('preRegisteration.email_temporary_password') }}
        </p>
        <button
          @click="redirectTo()"
          class="noqr-next-btn activ-btn"
          style="margin-top: 22px; margin-bottom: 25px"
          size="lg"
        >
          {{ $t('common.login').toUpperCase() }}
        </button>
      </div>

      <div
        v-if="getRegisterPassportAcc && getPhone && !getEmail"
        class="login-wrapper"
      >
        <img
          class="check-email-icon"
          src="@/assets/images/check-phone-msg.svg"
          alt="check your email"
        />
        <p class="check-email-title">{{ $t('preRegisteration.checkMessage') }}</p>
        <p class="check-email-msg">
          {{ $t('preRegisteration.sms_temporary_password') }}
        </p>
        <button
          @click="redirectTo()"
          class="noqr-next-btn activ-btn"
          style="margin-top: 22px; margin-bottom: 25px"
          size="lg"
        >
          {{ $t('common.login').toUpperCase() }}
        </button>
      </div>
    </div>

    <div class="diff-user-type-main-content" v-if="getDifferentUserType">
      <div class="reg-title">{{ $t('preRegisteration.different_user_type') }}</div>
      <div class="reg-msg">
        {{ $t('preRegisteration.switch_to_visitor',{ userType_from : getUserTypeName, userType_to: getSelectedUserType[0].name }) }}
      </div>
    </div>

    <div class="yes-no-wrapper" v-if="getDifferentUserType">
      <b-button @click="handelSelectDiffUserType()" class="yes-btn activ-btn">
        {{ $t('common.back')}}
      </b-button>
      <b-button @click="onFinish()" class="change-user-typebtn">
        {{ $t('preRegisteration.switch')}}
      </b-button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      notAllowToReg: false,
    };
  },
  computed: {
    ...mapGetters("userType", ["getTouchModeStatus", "getHostUserTypesExist"]),
    ...mapGetters("preRegistration", [
      "getDifferentUserType",
      "getUserTypeName",
      "getSelectedUserType",
      "getNotAllowedToRegister",
      "getCompliance",
      "getRegisterPassportAcc",
      "getFromLogin",
      "getEmail",
      "getPhone",
      "getUserEntity",
      "getSwitch",
      "getSections",
    ]),
  },
  methods: {
    ...mapActions("preRegistration", [
      "selectHasVisitedPage",
      "setSwitch",
      "selectRedirectLoader",
    ]),
    redirectTo() {
      window.location.href = `${
        process.env.VUE_APP_BASE_URL_PASSPORT_REDIRECT
      }/login?${
        this.getEmail ? "&email=" + encodeURIComponent(this.getEmail) : ""
      }
          ${
            this.getPhone ? "&phone=" + encodeURIComponent(this.getPhone) : ""
          }`;
    },

    onFinish() {
      this.setSwitch(true);
      if (
        (this.getCompliance.is_image_required && !this.getUserEntity?.image) ||
        (this.getTouchModeStatus && this.getHostUserTypesExist) ||
        this.getSections.length
      ) {
        setTimeout(() => {
          this.$emit("next");
        }, 500);
      } else {
        this.selectRedirectLoader(true);
        this.$emit("finish", "switch");
      }
    },
    handelSelectDiffUserType() {
      this.$emit("changeTab");
      this.selectHasVisitedPage(true);
      this.setSwitch(false);
      //   console.log('router', this.$router.currentRoute);
      //   this.selectSkipForm(true);
      //   this.$router.push('/pre-registration/' + this.$router.currentRoute.params.id);
    },
  },
};
</script>

<style lang="scss" scoped>
.visit-register {
  margin: auto;
  margin-top: 86px;
  margin-bottom: 86px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 491px;
  text-align: center;
  background: #ffffff;
  box-shadow: 0px 1px 40px 3px rgba(0, 0, 0, 0.05);
  border-radius: 26px;
  .main-content-msg {
    margin-bottom: 0px;
  }
  //   header
  .visit-register-header {
    .logo-2 {
      display: block;
      width: 86px;
      height: 16px;
      margin: 46px auto 21px auto;
      img {
        width: 86px;
        height: 16px;
      }
    }
    .reg-header {
      font-family: "SF Pro Display";

      font-weight: 700;
      font-size: 20px;
      line-height: 24px;
      text-transform: uppercase;
      text-align: center;

      color: #000000;
    }

    .form-title {
      font-family: "Roboto";

      font-weight: 900;
      font-size: 30px;
      line-height: 35px;
      text-align: center;

      color: #000000;
    }
    .sub-title {
      font-family: "Roboto";

      font-weight: 700;
      font-size: 16px;
      line-height: 30px;
      text-align: center;
      letter-spacing: 0.25px;
      color: #000000;
      margin-top: 15px;
      margin-bottom: 30px;
    }
    .noqr-sub-title {
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #000;
      margin-top: 143px;
      margin-bottom: 7px;
      letter-spacing: 0.15px;
    }
    .not-allow-reg-sub-title {
      @extend .noqr-sub-title;
      margin-top: 164px;
      margin-bottom: 14px;
    }
    .diff-usr-type-sub-title {
      @extend .not-allow-reg-sub-title;
    }
  }
  .reg-title {
    width: 421px;
    margin: 62px auto 42px auto;

    font-weight: 500;
    font-size: 16px;
    line-height: 30px;
    text-align: center;
    letter-spacing: 0.25px;
    color: #000000;
  }
  .diff-reg-title {
    width: 421px;
    margin: 38px auto 21px auto;

    font-weight: 500;
    font-size: 16px;
    line-height: 30px;
    text-align: center;
    letter-spacing: 0.25px;
    color: #000000;
  }
  .main-content {
    text-align: center;
    margin: 0;

    .content-message {
      font-family: "Roboto";
      font-weight: 400;
      font-size: 16px;
      line-height: 30px;
      text-align: center;
      letter-spacing: 0.25px;
      color: #787878;
      text-align: center;
      margin: 0 110px;
    }
    .qr-wrapper {
      width: 208px;
      height: 231px;
      background-color: #f3f3f3;
      border-radius: 8px;
      border: 2.5px solid #f3f3f3;
      margin: 49px auto 59px Auto;
      padding: 37px 33px 0px 33px;

      img {
        border-radius: 11px;
        border: 6.5px solid #000000;
        margin-bottom: 8px;
        width: 143px;
        height: 143px;
      }
      a {
        font-weight: 700;
        font-size: 14px;
        line-height: 17px;
        text-align: center;
        margin-bottom: 26px;
        color: #000000;
        white-space: nowrap;
      }
    }
    .apple-wallet-btn {
      border-radius: 0px;
      margin-bottom: 20px;
    }
    .googlepay-wallet-btn {
      margin-bottom: 68px;
    }
  }
  .no-qr-main-content {
    width: 390px;
    margin: 0 auto 47px;
  }
  .not-allow-reg-main-content {
    margin-bottom: 45px;
  }
  .diff-user-type-main-content {
    display: flex;
    flex-wrap: wrap;
    margin: 0 auto 58px auto;
    width: 421px;
    font-weight: 400;
    font-size: 16px;
    line-height: 27px;
    text-align: center;
    letter-spacing: 0.25px;
    color: #666666;
  }
  .diff-user-type-main-content-pass {
    display: flex;
    flex-wrap: wrap;
    margin: 0 auto 58px auto;
    width: 421px;
    font-weight: 400;
    font-size: 16px;
    line-height: 27px;
    text-align: center;
    letter-spacing: 0.25px;
    color: #666666;
  }
  .next-btn {
    height: 33px;
    width: 283px;
    border-radius: 18.5px;
    text-align: center;
    margin: 0 auto 44.5px;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
  }
  .noqr-next-btn {
    height: 37px;
    width: 197px;
    border-radius: 18.5px;
    text-align: center;
    margin: 0 auto 0px;
    line-height: 37px !important;
    letter-spacing: 0.25px;
    font-size: 14px;
  }
  .yes-no-wrapper {
    display: flex;
    justify-content: center;
    margin-bottom: 59px;
  }
  .yes-btn {
    height: 37px;
    width: 161px;
    border-radius: 18.5px;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    text-align: center;

    color: #ffffff;
    margin-inline-end: 34px;
  }
  .change-user-typebtn {
    height: 37px;
    width: 161px;
    border-radius: 18.5px;
    border: 2px solid #103f5e;
    background-color: #fff;
    color: #103f5e !important;
    font-weight: 700;
    font-size: 16px;
    line-height: 17px;
    text-align: center;
    letter-spacing: 0.25px;
  }
  .with-wrapper {
    .sep-line {
      margin-top: 41px !important;
      width: 421px;
      height: 1px;
      margin: auto;
      opacity: 0.08;
      background: #000000;
    }
    .wrapper-line {
      width: 421px;
      margin: auto;
      font-weight: 500;
      font-size: 14px;
      line-height: 23px;
      margin-top: 41px;
      margin-bottom: 35px;
      text-align: center;
      letter-spacing: 0.25px;

      color: #000000;
    }
  }
  .login-wrapper {
    width: 386px;
    border-radius: 17px;
    background-color: #f2f2f2;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    align-content: space-around;
    margin: 0px auto 37px auto;
    .check-email-icon {
      margin-top: 53px;
      margin-bottom: 24px;
    }
    .check-email-title {
      font-family: "Roboto";

      font-weight: 900;
      font-size: 16px;
      line-height: 19px;
      text-align: center;
      color: #103f5e;
    }
    .check-email-msg {
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      text-align: center;
      letter-spacing: 0.25px;
      color: #666666;
      margin: 0px 33px 35px 32px;
    }
  }
}
@media (max-width: 992px) {
  .visit-register {
    margin: auto;
    margin-top: 0px !important;
    margin-bottom: 0px !important;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    width: 390px;
    text-align: center;
    background: #ffffff;
    box-shadow: 0px 1px 40px 3px rgba(0, 0, 0, 0.05);
    border-radius: 0px;
    .main-content-msg {
      margin-bottom: 0px;
    }
    //   header
    .visit-register-header {
      .logo-2 {
        display: block;
        width: 116px;
        height: 22px;
        margin: 73px auto 28px auto;
        img {
          width: 116px;
          height: 22px;
        }
      }
      .reg-header {
        font-family: "SF Pro Display";

        font-weight: 700;
        font-size: 16px;
        line-height: 19px;
        text-align: center;
        text-transform: uppercase;
        color: #000000;
      }

      .form-title {
        font-family: "Roboto";

        font-weight: 900;
        font-size: 30px;
        line-height: 35px;
        text-align: center;

        color: #000000;
      }
      .sub-title {
        font-family: "Roboto";

        font-weight: 700;
        font-size: 16px;
        line-height: 30px;
        text-align: center;
        letter-spacing: 0.25px;
        color: #000000;
        margin-top: 15px;
        margin-bottom: 30px;
      }
      .noqr-sub-title {
        font-weight: 400;
        font-size: 14px;
        text-align: center;
        color: #000;
        margin-top: 143px;
        margin-bottom: 7px;
        letter-spacing: 0.15px;
      }
      .not-allow-reg-sub-title {
        @extend .noqr-sub-title;
        margin-top: 164px;
        margin-bottom: 14px;
      }
      .diff-usr-type-sub-title {
        @extend .not-allow-reg-sub-title;
      }
    }
    .reg-title {
      width: 315px;
      margin: 162px auto 14px auto;

      font-weight: 500;
      font-size: 14px;
      line-height: 30px;
      text-align: center;
      letter-spacing: 0.25px;
      color: #000000;
    }

    .main-content {
      text-align: center;
      margin: 0;

      .content-message {
        font-family: "Roboto";

        font-weight: 400;
        font-size: 16px;
        line-height: 30px;
        text-align: center;
        letter-spacing: 0.25px;
        color: #787878;

        text-align: center;
        margin: 0 110px;
      }
      .qr-wrapper {
        width: 208px;
        height: 231px;
        background-color: #f3f3f3;
        border-radius: 8px;
        border: 2.5px solid #f3f3f3;
        margin: 49px auto 59px Auto;
        padding: 37px 33px 0px 33px;

        img {
          border-radius: 11px;
          border: 6.5px solid #000000;
          margin-bottom: 8px;
          width: 143px;
          height: 143px;
        }
        a {
          font-weight: 700;
          font-size: 14px;
          line-height: 17px;
          text-align: center;
          margin-bottom: 26px;
          color: #000000;

          white-space: nowrap;
        }
      }
      .apple-wallet-btn {
        border-radius: 0px;
        margin-bottom: 20px;
      }
      .googlepay-wallet-btn {
        margin-bottom: 68px;
      }
    }
    .no-qr-main-content {
      width: 390px;
      margin: 0 auto 47px;
    }
    .not-allow-reg-main-content {
      margin-bottom: 45px;
    }
    .diff-user-type-main-content {
      display: flex;
      flex-wrap: wrap;
      margin: 0 auto 68px auto;
      width: 315px;
      font-weight: 400;
      font-size: 14px;
      line-height: 27px;
      text-align: center;
      letter-spacing: 0.25px;
      color: #666666;
    }
    .diff-user-type-main-content-pass {
      display: flex;
      flex-wrap: wrap;
      margin: 0 auto 396px auto;
      width: 315px;
      font-weight: 400;
      font-size: 14px;
      line-height: 27px;
      text-align: center;
      letter-spacing: 0.25px;
      color: #666666;
    }

    .diff-reg-title {
      width: 421px;
      margin: 38px auto 21px auto;
      font-weight: 500;
      font-size: 16px;
      line-height: 30px;
      text-align: center;
      letter-spacing: 0.25px;
      color: #000000;
    }
    .next-btn {
      height: 33px;
      width: 283px;
      border-radius: 18.5px;
      text-align: center;
      margin: 0 auto 44.5px;

      font-weight: 400;
      font-size: 16px;
      line-height: 19px;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #ffffff;
    }
    .noqr-next-btn {
      height: 37px;
      width: 197px;
      border-radius: 18.5px;
      text-align: center;
      margin: 0 auto 316px;
      line-height: 37px !important;
      letter-spacing: 0.25px;
      font-size: 14px;
    }
    .yes-no-wrapper {
      display: flex;
      justify-content: center;
      margin-bottom: 310px;
    }
    .yes-btn {
      height: 37px;
      width: 147px;
      border-radius: 18.5px;
      font-weight: 400;
      font-size: 14px;
      line-height: 17px;
      text-align: center;
      color: #ffffff;
      margin-inline-end: 24px;
    }
    .change-user-typebtn {
      height: 37px;
      width: 147px;
      border-radius: 18.5px;
      border: 2px solid #103f5e;
      background-color: #fff;
      color: #103f5e !important;

      font-weight: 700;
      font-size: 14px;
      line-height: 17px;
      text-align: center;
      letter-spacing: 0.25px;
    }
    .with-wrapper {
      .sep-line {
        margin-top: 41px !important;
        width: 308px;
        height: 1px;
        margin: auto;
        opacity: 0.08;
        background: #000000;
      }
      .wrapper-line {
        width: 313px;
        margin: auto;

        font-weight: 500;
        font-size: 14px;
        line-height: 23px;
        margin-top: 41px;
        margin-bottom: 35px;
        text-align: center;
        letter-spacing: 0.25px;

        color: #000000;
      }
    }
    .login-wrapper {
      width: 386px;
      border-radius: 17px;
      background-color: #f2f2f2;
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      align-content: space-around;
      margin: 0px auto 95px auto;
      .check-email-icon {
        margin-top: 53px;
        margin-bottom: 24px;
      }
      .check-email-title {
        font-family: "Roboto";

        font-weight: 900;
        font-size: 16px;
        line-height: 19px;
        text-align: center;
        color: #103f5e;
      }
      .check-email-msg {
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        text-align: center;
        letter-spacing: 0.25px;
        color: #666666;
        margin: 0px 33px 35px 32px;
      }
    }
  }
}
</style>
